import React, { useRef, useState } from "react";
import uploadBtnIcon from '../../../assets/upload-btn.svg';

const FileUploadButton = ({ getUploadedFiles, handleRemoveFile, handleFileChange, handleButtonClick, fileInputRef, setFiles,loading }) => {

    return (
        <div>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip"
                multiple
                style={{ display: "none" }}
            />

            <button onClick={handleButtonClick} className="file-upload-btn">
                <img src={uploadBtnIcon} alt="Upload" /> Upload 
                {loading && <div className=" ms-2 spinner-border  spinner-border-sm upload-spinner" role="status">
							<span className="visually-hidden"></span>
						</div>}
            </button>

            <style>
                {`
                .file-upload-btn {
                    padding: 7px 16px;
                    border: 2px solid var(--primaryColor) !important;
                    color: var(--primaryColor) !important;
                    background: transparent;
                    cursor: pointer;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-weight: 500;
                    font-size: 15px;
                }
                .uploaded-files {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                .file-item {
                    display: flex;
                    align-items: center;
                    border: 1.3px solid #C3CDDF;
                    padding: 5px 5px;
                    border-radius: 2px;
                }
                .delete-btn {
                    margin-left: 10px;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    color: red;
                    font-size: 14px;
                }
                .upload-spinner{
                    width: 15px !important;
                    height: 15px !important;
                    color: #572148 !important;
                }
                `}
            </style>
        </div>
    );
};

export default FileUploadButton;
